export default __webpack_public_path__ + "static/nurturefulth-ec9665809eaa8f985cf5aa61c69b7ab4.png";